<template>
  <div class="mb-4">
    <h5 class="color-main">FAQs</h5>
    <about-faqs-search :topics="topics" @onSearch="onSearch"></about-faqs-search>
    <div
      v-if="faqs.length"
      class="faqs-layout d-flex flex-wrap gap-4 justify-content-center align-items-center"
    >
      <atm-card class="faqs--item flex-grow-1" v-for="(faq, index) in faqs" :key="index">
        <p class="color-main">{{ faq.question }}</p>
        <p>{{ faq.answer }}</p>
        <div v-if="faq.topic" class="tag-container">
          <span class="tag">{{ faq.topic.name }}</span>
        </div>
      </atm-card>
    </div>
    <div v-else class="text-center mx-2 mt-5">
      <i class="material-icons border-2 full-icon rounded-circle align-middle border-0">
        question_answer
      </i>
      <p class="h4 text-xmuted mx-4 mt-3">
        Hello, for the moment there are no FAQS, we hope to answer your problem in the future.
      </p>
    </div>
  </div>
</template>

<script>
import atmCard from '@/components/atmCard.vue';
import AboutFaqsSearch from '@/common/components/about/AboutFaqsSearch.vue';
export default {
  components: { AboutFaqsSearch, atmCard },
  props: {
    faqs: {
      type: Array,
      default: () => [],
      required: true,
    },
    topics: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSearch({ search, type }) {
      this.$emit('onSearch', { search, type });
    },
  },
};
</script>

<style lang="scss" scoped>
.faqs-layout {
  display: flex;

  .faqs--item {
    min-width: 250px;
  }
  .tag-container {
    display: flex;
    justify-content: flex-end;
  }

  .tag {
    border-radius: 3px;
    padding: 0.2em 0.6em;
    border-radius: 6px;
    background: var(--color-main);
    color: white;
    font-size: small;
    font-weight: 500;
  }
}
</style>
